<template>
  <div class=" is-fullwidth">
    <table class="table is-hoverable is-fullwidth" id="orderstable">
    	<thead>
    		<th>Order ID</th>
   	 		<th>Date</th>
   	 		<th>Ref</th>
    	</thead>
    	<tbody>
		    <tr v-for="order in orders" v-bind:key="order.orderID">
				<td>{{order.orderID}}</td>
				<td>{{order.orderDate}}</td>
				<td>{{order.orderReference}}</td>
			</tr>
    	</tbody>
    </table>
    

    <Buttons v-if="$auth.user.roles.includes('sales')"/>
    
    
    
  </div>
</template>


<script>

import Buttons from '@/components/Buttons';
import OrderService from '@/services/OrderService.js';

export default {
  components: {
   	Buttons
  },
  data() {
    return {
      orders: [],
      errors: []
     
    }
  },
  

  // Fetches posts when the component is created.
  created() {
    this.getOrderData();
    
   
  },
  methods: {
  	
    async getOrderData() {
      const accessToken = await this.$auth.getTokenSilently()
      // Use the eventService to call the getEventSingle() method
      OrderService.getOrders(accessToken)
      .then(
        (orders => {
          this.$set(this, "orders", orders);
        }).bind(this)
      );
    }
  }
}

// used to be on button  v-if="this.user["https://app.test202.co.uk/roles"].includes('sales')"
</script>

<style>
	
</style>
